import {queryConfigs} from 'data/queryConfigs'
import {queryClient} from 'main'
import type {DepartmentType, StorableDepartment} from 'types/department'

export function invalidateDepartmentList(type: StorableDepartment['type']) {
  switch (type) {
    case 'ACT':
      queryClient.invalidateQueries({queryKey: queryConfigs.acts.list.queryKey})
      break
    case 'VENUE':
      queryClient.invalidateQueries({
        queryKey: queryConfigs.venues.list.queryKey,
      })
      break
    case 'ORGANIZER':
      queryClient.invalidateQueries({
        queryKey: queryConfigs.organizers.list.queryKey,
      })
      break
  }
}

export function invalidateDepartment(type: DepartmentType, id: number) {
  switch (type) {
    case 'ACT':
      queryClient.invalidateQueries({
        queryKey: queryConfigs.acts.show(id).queryKey,
      })
      break
    case 'VENUE':
      queryClient.invalidateQueries({
        queryKey: queryConfigs.venues.show(id).queryKey,
      })
      break
    case 'ORGANIZER':
      queryClient.invalidateQueries({
        queryKey: queryConfigs.organizers.show(id).queryKey,
      })
      break
  }
}
